import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

/** Groups the manager cockpit's attention drill-down walked into, outermost first. */
export const selectCockpitAttentionPath = createSelector(
  [selectFinancialCockpitState],
  ({ attentionPath }) => attentionPath
)

/** Grouping picked for the level the path ends on; `null` keeps that level's default. */
export const selectCockpitAttentionLevelGrouping = createSelector(
  [selectFinancialCockpitState],
  ({ attentionLevelGrouping }) => attentionLevelGrouping
)

/** Which cockpit the stored drill-down was started in; `null` before anything was picked. */
export const selectCockpitAttentionCockpitMode = createSelector(
  [selectFinancialCockpitState],
  ({ attentionCockpitMode }) => attentionCockpitMode
)

export const selectCockpitIsAttentionFullscreen = createSelector(
  [selectFinancialCockpitState],
  ({ isAttentionFullscreen }) => isAttentionFullscreen
)

export const selectCockpitAttentionRemindedEmails = createSelector(
  [selectFinancialCockpitState],
  ({ attentionRemindedEmails }) => attentionRemindedEmails
)

export const selectCockpitAttentionPbmReplacements = createSelector(
  [selectFinancialCockpitState],
  ({ attentionPbmReplacements }) => attentionPbmReplacements
)

/** The partner whose status detail the manager cockpit's tile has open, and the offering it answers. */
export const selectCockpitAttentionDetailPartner = createSelector(
  [selectFinancialCockpitState],
  ({ attentionDetailPartnerId, attentionDetailOffering }) =>
    attentionDetailPartnerId
      ? { partnerId: attentionDetailPartnerId, offering: attentionDetailOffering }
      : null
)
